import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { useEffect } from 'react';
import { Instagram } from './Instagram';

export interface StandaloneInstagramProps extends StandaloneComponentProps<typeof Instagram> {
  instagramHtml: string;
}

export const StandaloneInstagram: StandaloneComponent<StandaloneInstagramProps> = ({ instagramHtml, ...props }) => {
  useEffect(() => {
    const scriptSrc = 'https://platform.instagram.com/en_US/embeds.js';
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;

    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    if (window.instgrm && instagramHtml) {
      window.instgrm.Embeds.process();
    }
  }, [instagramHtml]);

  return <Instagram {...props}>{instagramHtml}</Instagram>;
};
